// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"LoadingSpinner_loading-spinner__3cFYp"};